export default axiosInstance => {
  async function query({ jwt }) {
    return (
      await axiosInstance({
        method: "get",
        url: "/liff/firstVisitForm",
        headers: {
          jwt
        }
      })
    ).data;
  }

  async function create({ jwt, data }) {
    return (
      await axiosInstance({
        method: "post",
        url: "/liff/firstVisitForm",
        headers: {
          jwt
        },
        data
      })
    ).data;
  }

  return {
    query,
    create
  };
};
